import { Observable } from "rxjs";
import { JoinedProduct } from "../productGrid";

export class ProductTableGroupAccounting {
    visibility(line:ProductTableLine) {
        return line.isOpen ? line.children.reduce((total, current)=>{ return total + ( current.type != 'group' ? 1 : current.visibleAmount + 1 ) } ,0) : 0;
    }
    groupAccount(line:ProductTableLine){
      return {
        cost: this.groupCost(line),
        sale: this.groupSale(line),
        hours: this.groupHours(line)
    }
    // In case group 0 amount should affect the price
        return {
            cost: line.amount != 0 ? this.groupCost(line) : 0,
            sale: line.amount != 0 ? this.groupSale(line) : 0,
            hours: line.amount != 0 ? this.groupHours(line) : 0
        }
    }
    groupCost(line:ProductTableLine){
        return line.children.reduce((total, current)=>{ return total + ( current.type != 'comment' ? current.totalCost : 0) },0)
    }
    groupSale(line:ProductTableLine){
        return line.children.reduce((total, current)=>{ return total + ( current.type != 'comment' ? current.totalSale : 0) },0)
    }
    groupHours(line:ProductTableLine){
        return line.children.reduce((total, current)=>{ return total + ( current.type == 'custom' && !!line.priceGroupId ? current.amount : current.type == 'group' ? current.hours : 0) },0)
    }
    groupArray(line):JoinedProduct[]{
        let list: JoinedProduct[] = [line.data];
        for(let x of line.children){ list = x.type == 'group' ? list.concat(x.groupArray) : list.concat(x.data) }
        return list
    }

    async sumTree(products): Promise<ProductTableTotals>{
      // In case groups should be allowed to have 0 amount, products within a group branch should be ignored
      // let zeroAmountGroups = products.filter(x => x.type == 'group' && x.amount == 0).map(x => x.description.replace('[ProductGroupId] ','')); 
      // console.log(zeroAmountGroups)
      let p = products.filter(x => x.type != 'group' && x.type != 'comment');
      let cost = p.filter(x => !x.priceGroupId ).reduce((sum,x) => sum + x.totalCost, 0).toFixed(2);
      let hourCost = p.filter(x => !!x.priceGroupId ).reduce((sum,x) => sum + (!!x.totalCost ? +x.totalCost : 0), 0).toFixed(2);
      let hourCoverage =  +p.reduce((sum,x)=> sum + (x.priceGroupId != null ? (x.sale - x.cost) * x.amount: 0) ,0).toFixed(2)
      let materialCoverage = +p.reduce((sum,x)=> sum + ( x.priceGroupId == null ? (x.sale - x.cost) * x.amount: 0 ),0).toFixed(2);
      let sales = p.reduce((sum,x)=> sum + (x.sale * x.amount) ,0);
      let hours = p.reduce((sum,x)=> x.priceGroupId != null ? sum + x.amount : sum ,0);
      let contributionMargin = sales - (+cost + +hourCost);
      return {
        cost: +cost,
        hourCost: +hourCost,
        totalCost: +cost + +hourCost,
        sale: sales,
        salePlusVat: +sales * 1.25,
        hours: hours,
        contributionMargin: +(contributionMargin).toFixed(2),
        contributionRatio: +(contributionMargin / sales * 100).toFixed(1),
        coveragePerHour: +(contributionMargin / hours).toFixed(2),
        hourCoverage: hourCoverage,
        materialCoverage: materialCoverage,
        hasSingleLines: false,
        singleLinesCost:0,
        isInit: false
      }
    }

    findPackages(productList:JoinedProduct[]){
      return Array.from(new Set(productList.filter(x => !!x.unitId ).map(x => x.unitId)))
    }
    async convertLinesToJoinedLines(o) : Promise<JoinedProduct[]>{
      let cus,pro,com,sub = [];
      cus = o.customLines.map(c => { return {
          id: c.id,
          description: c.name,
          number: '',
          cost: c.costPrice,
          sale: c.salesPrice,
          profit: c.profit,
          discount: c.discount,
          amount: c.quantity,
          image: '',
          sortOrder: c.sortOrder,
          totalCost: c.totalCostPrice,
          totalSale: c.totalSalesPrice,
          wholesaler: '',
          type: c.name.includes('ProductGroupId') ? 'group' : 'custom',
          companyProduct: false,
          manufacturer: '',
          priceGroupId: c.priceGroupId,
          unitId: c.packageId,
          path: c.path,
          accountId: null,
          hideOnPdf: c.showOnPdf
        } 
      });
      pro = o.productLines.map(p => {
        return {
          id: p.id,
          description: p.description,
          number: p.productNumber,
          cost: p.costPrice,
          sale: p.listPrice,
          profit: p.profit,
          discount: p.discount,
          amount: p.quantity,
          image: p.image,
          sortOrder: p.sortOrder,
          totalCost: p.totalCostPrice,
          totalSale: p.listPrice * p.quantity,
          wholesaler: p.wholeSaler,
          type: 'product',
          companyProduct: p.companyProduct,
          manufacturer: p.manufacturer,
          priceGroupId: null,
          unitId: p.packageId,
          path: p.path,
          accountId: p.accountId,
          hideOnPdf:p.showOnPdf
        }
      })
      com = !!o.commentLines ? o.commentLines.map(c => {
        return {
          id:c.id,
          description: c.comment,
          number:null,
          cost:null,
          sale:null,
          profit:null,
          discount:null,
          amount:null,
          image:null,
          sortOrder:c.sortOrder,
          totalCost:null,
          totalSale:null,
          wholesaler:null,
          type:'comment',
          companyProduct:null,
          manufacturer:null,
          priceGroupId:null,
          unitId:null,
          path: c.path,
          accountId:null,
          hideOnPdf:c.showOnPdf
        }
      }) : [];
      sub = !!o.subContractorLines ? o.subContractorLines.map(s => {
        return {
          id: s.id,
          description: s.name,
          number: '',
          cost: s.costPrice,
          sale: s.salesPrice,
          profit: s.profit,
          discount: s.discount,
          amount: s.quantity,
          image: '',
          sortOrder: s.sortOrder,
          totalCost: s.totalCostPrice,
          totalSale: s.totalSalesPrice,
          wholesaler: '',
          type: 'subcontractor',
          companyProduct: false,
          manufacturer: '',
          priceGroupId: s.priceGroupId,
          unitId: null,
          path: s.path,
          subcontractor: s.subContractor,
          accountId:null,
          hideOnPdf:s.showOnPdf
        }
      }):[];
      return cus.concat(pro).concat(com).concat(sub).sort((a,b)=> a.sortOrder < b.sortOrder ? -1 : 1 )
    }
}

export class ProductTableDOMFunctions {
  isEditable: boolean = true;
    getLineRefs():HTMLElement[]{
        return Array.from(document.getElementsByName('JubloTableProductLine')) as HTMLElement[];
    }
    async getlineFromSubTarget(el:HTMLElement): Promise<HTMLElement>{
        let line = el;
        for(var i = 0; i < 10;i++){
            line = line.parentNode as HTMLElement;
            if(line.getAttribute("name") == 'JubloTableProductLine'){
                return line as HTMLElement
                break
            }
        }
    }
    async getListAndRowIndex(el:HTMLElement): Promise<ListAndRowIndex>{
        let htmlArray = this.getLineRefs();
        let currentLine = await this.getlineFromSubTarget(el);
        let currentIndex = htmlArray.indexOf(currentLine);
        return {
            list: htmlArray,
            index : currentIndex
        }
    }
    edit(event:PointerEvent){
      if(this.isEditable){
        let t = event.target as HTMLElement;
        t.classList.add('hidden');
        let s = t.nextElementSibling as HTMLInputElement;
        s.classList.remove('hidden');
        s.focus();
        s.select();
      }
      }
    stopEditing(event){
        let t = event.target as HTMLInputElement;
        t.classList.add('hidden');
        let s = t.previousElementSibling as HTMLElement;
        s.classList.remove('hidden');
      }
    //   Table navigation
    keyCheck(event){
        if(event.keyCode == 9 || event.code == 'Tab') { event.preventDefault(); this.tabKey(event, event.shiftKey) }
        if(event.keyCode == 13 || event.code == 'Enter') { event.preventDefault(); this.enterKey(event, event.shiftKey) }
      }

    tabKey(event, reverse){
        // console.log('tab event', event)
        this.stopEditing(event);
        let tclass = event.target.classList as DOMTokenList;
        switch(event.target.dataset.type){
          case('description'):{
            if(reverse){ 
              this.lastInputPreviousLine(event);
            }
            else { 
              if(event.target.parentNode.parentNode.dataset.type == 'group') this.sameLineAmount(event);
              else this.nextInputSameLine(event)
             }
            break
          }
          case('amount'):{
            if(reverse){ 
              if(event.target.parentNode.parentNode.dataset.type == 'group') this.sameLineDescription(event);
              else this.previousInputSameLine(event);
            }
            else { 
              if(event.target.parentNode.parentNode.dataset.type == 'group') this.firstInputNextRow(event);
              else this.nextInputSameLine(event)
             }
             break
          }
          case('cost'):
          case('profit'):
          case('discount'):
          case('sale'): { 
            if(tclass.contains('ng-dirty')) { setTimeout(()=> {
              if(!reverse) this.nextInputSameLine(event);
              else this.previousInputSameLine(event);
              
            }, 200) }
            else { 
              if(!reverse) this.nextInputSameLine(event);
              else this.previousInputSameLine(event);
             }
            break 
          }
          case('totalSale'):{ 
            if(!reverse) this.firstInputNextRow(event); 
            else this.previousInputSameLine(event);
            break }
        }
      }
    
    enterKey(event,reverse){
      this.stopEditing(event);
      let tclass = event.target.classList as DOMTokenList;
      switch(event.target.dataset.type){
        case('description'):
        case('amount'):{
          if(!reverse) this.sameInputNextLine(event,false);
          else this.sameInputPreviousLine(event, false);
          ;break
        }
        default:{
          if(!reverse) this.sameInputNextLine(event,true);
          else this.sameInputPreviousLine(event, true);
        }
      }
    }

    async firstInputNextRow(event){
      // find current row
      let currentRow = await this.getlineFromSubTarget(event.target);
      let filteredList = this.getLineRefs().filter(x => x.dataset.type != 'comment');
      if(filteredList.length > 1 && filteredList.indexOf(currentRow) < filteredList.length - 1 ) {
          this.inputSwitch(filteredList[filteredList.indexOf(currentRow) + 1], 'description');
      }
      // check if another row exists
    }

    async lastInputPreviousLine(event){
      let currentRow = await this.getlineFromSubTarget(event.target);
      let filteredList = this.getLineRefs().filter(x => x.dataset.type != 'comment');
      if(filteredList.length > 1 && filteredList.indexOf(currentRow) > 0 ) {
        if(filteredList[filteredList.indexOf(currentRow) - 1].dataset.type == 'group') this.inputSwitch(filteredList[filteredList.indexOf(currentRow) - 1], 'amount');
        else this.inputSwitch(filteredList[filteredList.indexOf(currentRow) - 1], 'totalSale');
    }
    }

    inputSwitch(line:HTMLElement,inputType:string){
      let find = line.getElementsByClassName(inputType);
      let el = find[0] as HTMLElement;
      el.click()
    }

    nextInputSameLine(event){
      let t = event.target as HTMLInputElement;
      let ev = new MouseEvent('click');
      t.parentNode.nextSibling.childNodes[0].dispatchEvent(ev);
    }

    previousInputSameLine(event){
      let t = event.target as HTMLInputElement;
      let ev = new MouseEvent('click');
      t.parentNode.previousSibling.childNodes[0].dispatchEvent(ev);
    }
    async sameInputNextLine(event, filtered:boolean){
      // check that not last
      // filter lines to none groups
      let currentRow = await this.getlineFromSubTarget(event.target);
      let filteredList = !!filtered ? this.getLineRefs().filter(x => x.dataset.type == 'line') :  this.getLineRefs().filter(x => x.dataset.type != 'comment');
      if(filteredList.length > 1 && filteredList.indexOf(currentRow) < filteredList.length - 1 ) {
        this.inputSwitch(filteredList[filteredList.indexOf(currentRow) + 1], event.target.dataset.type);
      }
    }
    async sameInputPreviousLine(event, filtered:boolean){
      let currentRow = await this.getlineFromSubTarget(event.target);
      let filteredList = !!filtered ? this.getLineRefs().filter(x => x.dataset.type == 'line') :  this.getLineRefs().filter(x => x.dataset.type != 'comment');
      if(filteredList.length > 1 && filteredList.indexOf(currentRow) > 0 ) {
        this.inputSwitch(filteredList[filteredList.indexOf(currentRow) - 1], event.target.dataset.type);
      }
    }

    async sameLineAmount(event){
      let currentRow = await this.getlineFromSubTarget(event.target);
      let ev = new MouseEvent('click');
      this.inputSwitch(currentRow, 'amount');
    }

    async sameLineDescription(event){
      let currentRow = await this.getlineFromSubTarget(event.target);
      let ev = new MouseEvent('click');
      this.inputSwitch(currentRow, 'description');
    }
}

export class ProductTableDraggingFunctions {
    findElementToClone(target:HTMLElement, color:string){
        let clone = target.cloneNode(true) as HTMLElement;
        clone.style.background = color;
        clone.style.border = '1px solid skyblue';
        clone.style.height = '38px';
        clone.style.alignItems = 'center';
        clone.style.padding = '0 0.4rem';
        clone.style.zIndex = '9999999';
        return clone
      }
}

export class ProductTableTransformJoinedProducts {
    JPtoProductTree(p : JoinedProduct[], previousPaths):TableTreeAndPaths{
      // var tree = []
      // putting orphans into tree
      var tree = this.transformLines(p.filter(x => x.type != 'group' && !x.path));
      var currentProduct, mappedElem;
      let productPaths = {};
      let groups = this.transformGroups(p);
      let products = this.transformLines(p.filter(x => x.type != 'group'));

      for (var i = 0, len = groups.length; i < len; i++) {
        currentProduct = groups[i];
        productPaths[currentProduct.path] = currentProduct;
        if(currentProduct.type == 'group') productPaths[currentProduct.path]['children'] = [
            ...products.filter(x => x.path == currentProduct.path)
        ];
      }
      for (var id in productPaths) {
        if (productPaths.hasOwnProperty(id)) {
          mappedElem = productPaths[id];
          // If the element is not at the root level, add it to its parent array of children.
          if (mappedElem.parentPath && productPaths[mappedElem['parentPath']]) {
            productPaths[mappedElem['parentPath']]['children'].push(mappedElem);
          }
          // If the element is at the root level, add it to first level elements array.
          else {
            tree.push(mappedElem);
          }
        }
      }
      // check for orphan products
      tree = tree.concat(this.transformLines(p.filter(x => x.type != 'group' && !!x.path && !productPaths[x.path] && !previousPaths[x.path]).map(x => { return { ...x, path:null  }  })   ))
      tree = tree.concat(this.transformLines(p.filter(x => !!previousPaths[x.path])));
      return {
          tree : tree.sort((a,b)=> a.sortOrder < b.sortOrder ? -1 : 1),
          productPaths: productPaths
      }
    }
    public transformGroups(p:JoinedProduct[]):ProductTableLine[]{
      return p.filter(x => x.type == 'group').map(x => 
        { 
            return {
                ...x, 
                description: x.description.split('[ProductGroupId]').join('').trim(), // remove group tag from custom line, not removed in data.
                data: x, // add JoinedProduct into dataset to be used in dom
                hours:0, // deprecated
                isOpen: false, 
                children:[], // deprecated
                visibleAmount: 0, // used for height styling of the group
                parentPath: this.getParentPath(x.path)
            } 
        }
          )
    }
    public transformLines(p:JoinedProduct[]):ProductTableLine[]{
      return p.filter(x => x.type != 'group').map(x => {
        return {
          ...x, 
          data:x, 
          parentPath:x.path,
          id: x.id
        }
      })
    }
    getParentPath(path){
        return !path || !path.includes('//') ? null : path.split('//').slice( 0, path.split('//').length -1 ).join('//')
    }
    async renameGroupChildrenPaths(group:ProductTableLine, parentPath){
        group.parentPath = parentPath;
        group.path = !!parentPath ? parentPath + '//' + group.description : group.description;
        group.data.path = !!parentPath ? parentPath + '//' + group.description : group.description;
        for(let x of group.children){
            if (x.type == 'group') this.renameGroupChildrenPaths(x, group.path)
            else {
                x.path  = group.path;
                x.data.path = group.path;
            }
        }
    }
   async getGroupContentFromGroup(group):Promise<JoinedProduct[]>{
        let a = [group.data];
        for (let x of group.children){
            if(x.type != 'group') a.push(x.data);
            else a = a.concat(await this.getGroupContentFromGroup(x))
        }
        return a
    }
    insertProductsIntoProductTable(p:JoinedProduct[], paths:Object){
      return new Observable((observer)=> {
        this.checkForDuplicateGroups(p, paths).subscribe(
          (data)=> { p = data; },()=>{},
          ()=> {
            this.separateOrphans(p,paths).subscribe(
              (d)=> {  
                observer.next(d);
                observer.complete()
              }
            )
          }
        )
      })
    }

    checkForDuplicateGroups(p:JoinedProduct[], paths:Object):Observable<JoinedProduct[]>{
      return new Observable((observer)=>{
        let existingPaths = Object.keys(paths);
        let dupliGroups = p.filter(x => x.type == 'group' && existingPaths.includes(x.path)).map(x => x.path);
        if(!!dupliGroups && dupliGroups.length == 0){
          observer.next(p);
          observer.complete();
        }
        else {
         // 
         observer.next(p.map(x => {
           return {
             ...x,
             description: x.type == 'group' && dupliGroups.includes(x.path) ? (x.description + ' copy'): x.description,
             path : !!x.path && dupliGroups.includes(x.path) ? x.path.replace(x.path,''): x.path
           }
         }));
         observer.complete();

        }
      })
    }

    separateOrphans(p:JoinedProduct[], paths:Object){
      return new Observable((observer)=>{
        var currentProduct, mappedElem;
        let orphans = this.transformLines(p.filter(x => x.type != 'group' && !x.path || x.type != 'group' && !!paths[x.path]));
        let products = this.transformLines(p.filter(x => x.type != 'group' && !!x.path));
        let groups = this.transformGroups(p.filter(x => x.type == 'group'));
        let newPaths = {}
        for(var i = 0; i < groups.length; i++) {
          currentProduct = groups[i];
          newPaths[currentProduct.path] = currentProduct;
          if(currentProduct.type == 'group') newPaths[currentProduct.path]['children'] = [
            ...products.filter(x => x.path == currentProduct.path)
        ];
        }
        for (var id in newPaths) {
          if (newPaths.hasOwnProperty(id)) {
            mappedElem = newPaths[id];
            // If the element is not at the root level, add it to its parent array of children.
            if (mappedElem.parentPath && newPaths[mappedElem['parentPath']]) {
              newPaths[mappedElem['parentPath']]['children'].push(mappedElem);
            }
            // If the element is at the root level, add it to first level elements array.
            else {
              orphans.push(mappedElem);
            }
          }
        }
        observer.next({
          paths: newPaths,
          orphans : orphans
        });
        observer.complete()
      })
    }

  }

export class ProductTableLine extends JoinedProduct {
  children?: Array<ProductTableLine> = [];
  isOpen?:boolean = true;
  visibleAmount?:number;
  data: JoinedProduct;
  hours?:0;
  parentPath: string;
  constructor(p:JoinedProduct){
    super();
    for(var i in p){
      this[i] = p[i]
    }
  }
}

export class ProductTableGroups extends JoinedProduct {
  

}
export interface TableTreeAndPaths {
  tree: ProductTableLine[];
  productPaths:Object
}

export interface ListAndRowIndex {
    list: HTMLElement[],
    index:number
}

export interface ProductTableTotals {
  cost:number;
  hourCost:number;
  totalCost:number;
  sale:number;
  salePlusVat:number;
  hours:number;
  contributionMargin: number;
  contributionRatio: number;
  coveragePerHour: number;
  hourCoverage: number;
  materialCoverage: number;
  hasSingleLines:boolean;
  singleLinesCost:number;
  isInit:boolean;
}